import { Directive, HostListener } from '@angular/core';
import { WizardService } from './wizard.service';

@Directive({
	selector: '[pgsPreviousStep]'
})
export class PreviousStepDirective {

	constructor(private wizardService: WizardService) { }

	@HostListener('click')
	onClick(): void {
		this.wizardService.previousStep();
	}

}
